import type { createBrowserRouter } from "react-router-dom";

type AppRouter = ReturnType<typeof createBrowserRouter>;

/**
 * Leaf registry for the app router instance so non-React code (e.g. redux
 * epics) can navigate without importing the router module directly.
 */
let router: AppRouter | undefined;

export function registerRouter(instance: AppRouter) {
	router = instance;
}

export function getRouter(): AppRouter {
	if (router === undefined) {
		throw new Error("getRouter() called before registerRouter()");
	}
	return router;
}
